// extracted by mini-css-extract-plugin
export default {"controle":"SegmentedControl_controle__5jrOr","opcao":"SegmentedControl_opcao__yyWrs","ativa":"SegmentedControl_ativa__Inor2"};